import React, { Fragment, useEffect } from "react";
import {
  clearEducationDetail,
  fetchDeleteEducation,
} from "../actions/education";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { fetchEducationList } from "../actions/education";
import { statusRender } from "../utils/cellRenderTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const EducationList = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "education";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { educationList } = useSelector((state) => state.educationReducer);

  useEffect(() => {
    dispatch(fetchEducationList());
    dispatch(clearEducationDetail());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/education-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeleteEducation(pageId));
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("educationList.name"),
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    {
      headerName: t("educationList.countryName"),
      field: "countryName",
      filter: "agSetColumnFilter",
      minWidth: 150,
    },
    {
      headerName: t("educationList.points"),
      field: "points",
      filter: "agTextColumnFilter",
      minWidth: 100,
    },
    {
      headerName: t("educationList.duration"),
      field: "duration",
      filter: "agTextColumnFilter",
      minWidth: 100,
    },
    {
      headerName: t("educationList.status"),
      field: "status",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "INACTIVE":
            return t("educationList.statusInactive");
          case "ACTIVE":
            return t("educationList.statusActive");
          case "ARCHIVE":
            return t("educationList.statusArchive");
          default:
            return "";
        }
      },
      width: 150,
    },
    {
      headerName: t("educationList.createdAt"),
      field: "createdAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: t("educationList.updatedAt"),
      field: "updatedAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={educationList}
        columnDefs={columnDefs}
        buttonLink={`/education-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey={"education-list"}
      />
    </Fragment>
  );
};

export default EducationList;
